/**
 * Which workspace an answer of the chat store belongs to (KAN-1748).
 *
 * A workspace switch resets the store (``reset``), but it cannot stop the
 * requests already on their way, and their answers belong to the workspace the
 * tab has just left. An action that writes after a request therefore captures
 * the workspace before the request and asks before every write whether the
 * store is still in it. Every ``reset`` (workspace switch, sign-out) starts a
 * new generation, and all earlier captures go stale.
 *
 * Opening a chat checks something finer, whether the chat is still the one
 * being opened (``load-chat.ts``), which a reset ends too.
 */

let generation = 0;

/** Asks whether the store is still in the workspace it was captured in. */
export type SameWorkspace = () => boolean;

/** For ``reset``: every workspace captured so far is left behind. */
export function startNewWorkspace(): void {
  generation += 1;
}

/** Capture the store's workspace now, before the request whose answer it writes. */
export function captureWorkspace(): SameWorkspace {
  const captured = generation;
  return () => captured === generation;
}
